module.exports = __webpack_public_path__ + "static/artist-development-case-study-mobile-c54024396b53fbee81cf3c87876655d5.webp";